module.exports = __webpack_public_path__ + "assets/img/1506_04.jpg?5eca317ce5425d4e35bac9d2aeec8835";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1506_04.jpg
// module id = 1089
// module chunks = 0